import { ActionsUnion, createAction } from 'spw-redux/types';
import { SortBy } from 'spw-components/collab/types';
import { IUserFilter } from '../../../admin/data-provider';
import { IUser } from '../user/types';
import { TeamSlimForList, TeamsSortParams } from '../teams/types';
import { ProjectSlimForList, ProjectsSortingParams } from '../projects/types';
import {
  GetBenchmarkReportsParams,
  PaginatedBenchmarkReports,
} from '../benchmark-reports/types';

export const FETCH_USERS = 'users/FETCH_USERS';
export const FETCH_USERS_SUCCEEDED = 'users/FETCH_USERS_SUCCEEDED';

export const GET_SELECTED_USER = 'users/GET_SELECTED_USER';
export const GET_SELECTED_USER_SUCCEEDED = 'users/GET_SELECTED_USER_SUCCEEDED';
export const GET_SELECTED_USER_FAILED = 'users/GET_SELECTED_USER_FAILED';

export const GET_TEAMS_FOR_SELECTED_USER = 'users/GET_TEAMS_FOR_SELECTED_USER';
export const GET_TEAMS_FOR_SELECTED_USER_SUCCEEDED =
  'users/GET_TEAMS_FOR_SELECTED_USER_SUCCEEDED';
export const GET_TEAMS_FOR_SELECTED_USER_FAILED =
  'users/GET_TEAMS_FOR_SELECTED_USER_FAILED';

export const GET_PROJECTS_FOR_SELECTED_USER =
  'users/GET_PROJECTS_FOR_SELECTED_USER';
export const GET_PROJECTS_FOR_SELECTED_USER_SUCCEEDED =
  'users/GET_PROJECTS_FOR_SELECTED_USER_SUCCEEDED';
export const GET_PROJECTS_FOR_SELECTED_USER_FAILED =
  'users/GET_PROJECTS_FOR_SELECTED_USER_FAILED';

export const ASSIGN_USER_AS_ORG_ADMIN = 'users/ASSIGN_USER_AS_ORG_ADMIN';
export const ASSIGN_USER_AS_ORG_ADMIN_SUCCEEDED =
  'users/ASSIGN_USER_AS_ORG_ADMIN_SUCCEEDED';
export const ASSIGN_USER_AS_ORG_ADMIN_FAILED =
  'users/ASSIGN_USER_AS_ORG_ADMIN_FAILED';

export const SET_USER_FAVORITE_PROJECT = 'users/SET_USER_FAVORITE_PROJECT';
export const SET_USER_FAVORITE_REPORT = 'users/SET_USER_FAVORITE_REPORT';

export const CHANGE_PROJECT_OWNER = 'CHANGE_PROJECT_OWNER';

export const REFETCH_PROJECTS_FOR_SELECTED_USER_STARTING_FROM_PAGE =
  'users/REFETCH_PROJECTS_FOR_SELECTED_USER_STARTING_FROM_PAGE';
export const REFETCH_PROJECTS_FOR_SELECTED_USER_STARTING_FROM_PAGE_SUCCEEDED =
  'users/REFETCH_PROJECTS_FOR_SELECTED_USER_STARTING_FROM_PAGE_SUCCEEDED';
export const REFETCH_PROJECTS_FOR_SELECTED_USER_STARTING_FROM_PAGE_FAILED =
  'users/REFETCH_PROJECTS_FOR_SELECTED_USER_STARTING_FROM_PAGE_FAILED';

export const GET_REPORTS_FOR_SELECTED_USER =
  'users/GET_REPORTS_FOR_SELECTED_USER';
export const GET_REPORTS_FOR_SELECTED_USER_SUCCEEDED =
  'users/GET_REPORTS_FOR_SELECTED_USER_SUCCEEDED';

export const fetchUsers = (
  filterValues: IUserFilter,
  sortBy: SortBy,
  page: number,
  itemsPerPage: number
) => createAction(FETCH_USERS, { filterValues, sortBy, page, itemsPerPage });

export const fetchUsersSucceeded = (payload: {
  users: IUser[];
  total: number;
}) => createAction(FETCH_USERS_SUCCEEDED, payload);

export const getSelectedUser = (userId: number) =>
  createAction(GET_SELECTED_USER, userId);
export const getSelectedUserSucceeded = (user: IUser) =>
  createAction(GET_SELECTED_USER_SUCCEEDED, user);

export const getSelectedUserFailed = () =>
  createAction(GET_SELECTED_USER_FAILED);

export const getTeamsForSelectedUser = (
  userId: number,
  sort?: TeamsSortParams
) => createAction(GET_TEAMS_FOR_SELECTED_USER, { userId, ...sort });

export const getTeamsForSelectedUserSucceeded = (results: {
  total: number;
  teams: TeamSlimForList[];
}) => createAction(GET_TEAMS_FOR_SELECTED_USER_SUCCEEDED, results);

export const getTeamsForSelectedUserFailed = () =>
  createAction(GET_TEAMS_FOR_SELECTED_USER_FAILED);

export const getProjectsForSelectedUser = (payload: {
  userId: number;
  sort?: ProjectsSortingParams;
  page?: number;
}) => createAction(GET_PROJECTS_FOR_SELECTED_USER, payload);

export const getProjectsForSelectedUserSucceeded = (payload: {
  projects: ProjectSlimForList[];
  total: number;
  lastSortUsed: ProjectsSortingParams;
}) => createAction(GET_PROJECTS_FOR_SELECTED_USER_SUCCEEDED, payload);

export const getReportsForSelectedUser = (params: GetBenchmarkReportsParams) =>
  createAction(GET_REPORTS_FOR_SELECTED_USER, params);

export const getReportsForSelectedUserSucceeded = (
  paginatedReports: PaginatedBenchmarkReports
) => createAction(GET_REPORTS_FOR_SELECTED_USER_SUCCEEDED, paginatedReports);

export const getProjectsForSelectedUserFailed = () =>
  createAction(GET_PROJECTS_FOR_SELECTED_USER_FAILED);

export const assignUserAsOrgAdmin = (
  user: {
    id: number;
    isOrgAdmin: boolean;
  },
  onSuccess: () => void
) => createAction(ASSIGN_USER_AS_ORG_ADMIN, { user, onSuccess });
export const assignUserAsOrgAdminSucceeded = (isOrgAdmin: boolean) =>
  createAction(ASSIGN_USER_AS_ORG_ADMIN_SUCCEEDED, { isOrgAdmin });
export const assignUserAsOrgAdminFailed = () =>
  createAction(ASSIGN_USER_AS_ORG_ADMIN_FAILED);

export const setUserFavoriteProject = (projectId: number, newValue: boolean) =>
  createAction(SET_USER_FAVORITE_PROJECT, { projectId, newValue });
export const setUserFavoriteReport = (reportId: number, newValue: boolean) =>
  createAction(SET_USER_FAVORITE_REPORT, { reportId, newValue });

export const changeProjectOwner = (projectId: number, projectOwner: IUser) =>
  createAction(CHANGE_PROJECT_OWNER, { projectId, projectOwner });

export const refetchProjectsForSelectedUserStartingFromPage = (payload: {
  userId: number;
  startingPage?: number;
}) =>
  createAction(REFETCH_PROJECTS_FOR_SELECTED_USER_STARTING_FROM_PAGE, payload);

export const refetchProjectsForSelectedUserStartingFromPageSucceeded = (payload: {
  projects: ProjectSlimForList[];
  total: number;
  startingPage: number;
}) =>
  createAction(
    REFETCH_PROJECTS_FOR_SELECTED_USER_STARTING_FROM_PAGE_SUCCEEDED,
    payload
  );
export const refetchProjectsForSelectedUserStartingFromPageFailed = () =>
  createAction(REFETCH_PROJECTS_FOR_SELECTED_USER_STARTING_FROM_PAGE_FAILED);

export const actions = {
  fetchUsers,
  fetchUsersSucceeded,
  getSelectedUser,
  getSelectedUserSucceeded,
  getSelectedUserFailed,
  getTeamsForSelectedUser,
  getTeamsForSelectedUserSucceeded,
  getTeamsForSelectedUserFailed,
  getProjectsForSelectedUser,
  getProjectsForSelectedUserSucceeded,
  getProjectsForSelectedUserFailed,
  assignUserAsOrgAdmin,
  assignUserAsOrgAdminSucceeded,
  assignUserAsOrgAdminFailed,
  setUserFavoriteProject,
  setUserFavoriteReport,
  changeProjectOwner,
  refetchProjectsForSelectedUserStartingFromPage,
  refetchProjectsForSelectedUserStartingFromPageSucceeded,
  refetchProjectsForSelectedUserStartingFromPageFailed,
  getReportsForSelectedUser,
  getReportsForSelectedUserSucceeded,
};

export type Actions = ActionsUnion<typeof actions>;
